// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M11.04.036C8.656.238 6.437 1.104 4.596 2.553c-4.498 3.54-5.886 9.744-3.32 14.835A11.988 11.988 0 0 0 12 24c1.89 0 3.703-.43 5.388-1.277a12.051 12.051 0 0 0 5.057-4.807c.86-1.511 1.422-3.367 1.522-5.023.009-.149.025-.276.036-.283.012-.007.02-.296.02-.641 0-.346-.009-.615-.02-.597-.012.018-.026-.086-.036-.252-.095-1.651-.66-3.52-1.522-5.036A12.033 12.033 0 0 0 13.62.107a13.385 13.385 0 0 0-2.58-.071m.216 1.491c-1.459.13-2.602.436-3.828 1.027a10.544 10.544 0 0 0-4.874 4.874 10.488 10.488 0 0 0-.987 3.396c-.06.496-.06 1.856 0 2.352.213 1.745.794 3.311 1.748 4.717.197.29.684.924.734.955.012.007 3.351-3.316 7.42-7.386l7.4-7.398-.129-.109c-1.538-1.302-3.446-2.124-5.54-2.385-.287-.036-1.679-.067-1.944-.043m1.274 11.01-7.398 7.4.128.108a10.548 10.548 0 0 0 4.94 2.296c.642.113.933.134 1.8.134s1.158-.021 1.8-.134a10.53 10.53 0 0 0 4.716-2.115c2.04-1.634 3.38-3.883 3.825-6.426.113-.642.134-.933.134-1.8s-.021-1.158-.134-1.8a10.539 10.539 0 0 0-2.39-5.048c-.012-.007-3.351 3.316-7.42 7.386M.01 12c0 .35.003.493.007.318s.004-.461 0-.636S.01 11.65.01 12"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const CancelIcon = Icon;
export default CancelIcon;
